import { Component } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { messages } from '../../funciones/mensajes';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { Actividades, Proyectos } from '../../../models/Formulacion/indicadores-metas/datos';
import { ProyectosService } from '../../../services/gestion/proyectos/proyectos.service';
import { ActividadService } from '../../../services/gestion/actividad/actividad.service';
import { AdicionalService } from '../../../services/gestion/adicional/adicional.service';

@Component({
  selector: 'app-altaproyectos',
  templateUrl: './altaproyectos.component.html',
  styleUrl: './altaproyectos.component.css'
})
export class AltaproyectosComponent {

  encabezados = ["","","","","","","","",""]
  
  registros = [];
  allProyects = [];
  adicionales = [];

  canUpload = false;

  proyectosAlta = true;
  
  total = 0;
  ready = 0;
  error = 0;

  completeAll = false;

  idPlanificacion = 0;

  objetivos = [];
  responsables = [];
  estrategia = [];
  actividades = [];

  constructor(
    public dataService: DataService,
    private cookieService: CookieService,
    private translate: TranslateService,

    private planificacionService: PlanificacionService,
    private objetivosService: ObjetivoService,
    private readonly responsableService: ResponsableService,
    private readonly proyectosService: ProyectosService,
    private readonly actividadService: ActividadService,
        private readonly adicionalService: AdicionalService
  ){
    this.obtenerData();
  }
  /**
   * Obtener data
   */
  async obtenerData(){
    this.objetivos = [];
    this.idPlanificacion = Number(this.cookieService.get('idInstitucion'));
    this.responsables = [];
    const plan = await this.planificacionService.getPlanificacionByIdGQL(this.idPlanificacion);
    const res2 = await firstValueFrom(this.responsableService.getResponsable());
    for(const are of res2){
      if(Number(are.institution.id) === Number(plan.institution.id)){
        for(const res of are.responsibles){
          this.responsables.push({
            nombre: res.position,
            id: res.id,
            check: true,
            institucion: are.institution.name,
          });
        }
      }
    }
    
    var strat = [], proyects = [];
    for( const per of plan.perspectives){
      const obj = await this.objetivosService.getObjectivesByPerspectiveGQL(Number(per.id))
      const objs = obj.map(o =>{
        strat = strat.concat(o.strategies.map(s => {return s}))
        proyects = proyects.concat(o.projects.map(s => {return s.id}))
        return {
          nombre: o.name,
          descripcion: o.description, 
          ponderacion: o.weighing, 
          perspectiveId: per.id,
          strategias: o.strategies,
          projects: o.projects,
          id: o.id,
        }
      });
      this.objetivos = this.objetivos.concat(objs);
    }

    const projects = [];
    for (let i = 0; i < proyects.length; i += 10) {
      const batch = proyects.slice(i, i + 10);
      const results = await this.proyectosService.getProyectsGQL(batch);
      projects.push(...results);
    }
    
    this.adicionales = projects[0].activities[0]?.additions ?? [];
    this.allProyects = projects.flatMap(p => {
      const o = this.objetivos.find(o => o.id === p.objectives[0].id)
      
      var aux = [];

      aux.push({
        tipo: 'p',
        name: p.name,
        description: p.description,
        responsableId: p.responsible.position,
        objetiveId: o.nombre,
        programaId: p.strategies[0]?.name??'',
        strategiasFiltro: p.strategies,
      });

      aux = aux.concat(
        p.activities.map(a => {
        return {
          tipo: 'a',
          name: a.name,
          responsableId: p.responsible.position,
          fecha_inicio: a.initial_date,
          fecha_fin: a.end_date
        }
      })
    );

      return aux; 
    });
    // this.estrategia = strat;
    this.canUpload = true;
  }
  /**
   * Plantillas de excel
   */
  async downloadPlantilla(){
    const link = document.createElement('a');
    link.href = 'assets/Plantillas/Plantilla-proyectos.xlsx';
    link.download = 'plantilla-proyectos.xlsx';
    link.click();
  }
  async uploadPlantilla() {
    if(this.adicionales.length !== 0){
      messages.infoMessageGraph('No se puede dar de alta ya tienes adicionales cargados');
      return ;
    }

    this.registros = [];
    this.total = 0;
    this.error = 0;
    this.ready = 0;

    let guardo = false;

    const introdujo = await Swal.fire({
      title: this.translate.instant('gestion.seguimiento.proy-estra.selecArch'),
      input: 'file',
      inputValue: '',
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },

      inputValidator: (value) => {

        if (!value) {
          return this.translate.instant('gestion.seguimiento.proy-estra.datoInvalido');
        }

        guardo = true;

        return '';
      }
    });

    if (guardo) {
      try {
        const file: File = introdujo.value;
        const reader = new FileReader();

        reader.onload = (e: any) => {
          const binaryString = e.target.result;
          const workbook = XLSX.read(binaryString, {
            type: 'binary'
          });
          // HOJAS
          const proyectosSheet = workbook.Sheets['Proyectos'];
          const actividadesSheet = workbook.Sheets['Actividades'];
          // JSON
          const proyectos = XLSX.utils.sheet_to_json(proyectosSheet);
          const actividades = XLSX.utils.sheet_to_json(actividadesSheet);
          // RELACIONAR
          
          try{
            const nombres = new Set();
            for (const p of proyectos) {
              const nombre = p['Nombre'];

              if (nombres.has(nombre)) {
                throw new Error(`El nombre del proyecto "${nombre}" se repite en el excel.`);
              }

              nombres.add(nombre);
            }

            for(const p of this.allProyects){
              if(p.name === p['Nombre']){
                throw new Error(`El nombre del proyecto "${p['Nombre']}" Ya esta dado de alta.`);
              }
            }
          }catch(err){
            messages.infoMessageGraph(err.message);
            return;
          }

          const proyectosFin = proyectos.flatMap( p => {
            var aux = [];

            aux.push({
              status: false,
              tipo: 'p',
              name: p['Nombre'],
              description: p['Descripción'],
              responsableId: 0,
              objetiveId: 0,
              programaId: 0,
              strategiasFiltro: [],
            });

            const act = actividades.filter(a => a['ID Proyecto'] === p['ID Proyecto']);

            aux = aux.concat(
              act.map(a => {
                return {
                  status: false,
                  tipo: 'a',
                  name: a['Nombre Actividad'],
                  responsableId: 0,
                  fecha_inicio: this.parseExcelDate(a['Inicio']),
                  fecha_fin: this.parseExcelDate(a['Fin'])
                }
              })
            );

            return aux;
          });
          
          this.registros = proyectosFin;
          
          this.total = this.registros.length;
          this.error = this.registros.length;
        };
        reader.readAsBinaryString(file);
      }catch(err){
        messages.errorMessageGraph(err);
        return;
      }
    }
  }
  private parseExcelDate(value: any): String | null {
    if (!value) return null;

    const excelDate = moment('1899-12-30');
    return excelDate
      .add(value, 'days')
      .format('YYYY-MM-DD');
  }
  /**
   * Metodos de guardados
   */
  public async selecSave(){
    try{
      for(const i of this.registros){
        var p;
        if(i.tipo === 'p'){
          p = await this.guardarPro(i)
        }else{
          await this.guardarAct(i, p);
        }
      }
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      this.registros = [];
      this.total = 0;
      this.error = 0;
      this.ready = 0;
    }catch(err){
      messages.errorMessageGraph(err);
    }
  }
  public async guardarPro(proy: any){
    var proyecto = new Proyectos();
    proyecto.nombre = proy.name;
    proyecto.descripcion = proy.description;
    proyecto.objetiveId = [proy.objetiveId];
    proyecto.responsibleId = proy.responsableId;
    if(proy.programaId !== 0){
      proyecto.programaId = proy.programaId;
    }

    try{
      const res = await firstValueFrom(this.proyectosService.postProyectos(proyecto));
      const o = this.objetivos.find(o => Number(o.id) === Number(proyecto.objetiveId));
      const r = this.responsables.find(r => Number(r.id) === Number(proyecto.responsibleId))
      const e = proy.strategiasFiltro.find(e => Number(e.id) === Number(proyecto.programaId))
      this.allProyects.push({
        tipo: 'p',
        name: proyecto.nombre,
        description: proyecto.description,
        responsableId: r.nombre,
        objetiveId: o.nombre,
        programaId: e?.name ??''
      });

      return res;
    }catch(err){
      messages.errorMessageGraph(err);
      return null;
    }
  }
  public async guardarAct(act: any, proyectId: any){
      var actividad = new Actividades();
      actividad.nombre = act.name;
      actividad.responsibleId = act.responsableId;
      actividad.projectId = proyectId.id;
      actividad.fecha_inicio = new Date(act.fecha_inicio);
      actividad.fecha_fin = new Date(act.fecha_fin);
      try{
        await firstValueFrom(this.actividadService.postActividades(actividad));
        const r = this.responsables.find(r => Number(r.id) === Number(actividad.responsibleId))
        this.allProyects.push({
          tipo: 'a',
          name: actividad.nombre,
          responsableId: r.nombre,
          fecha_inicio: actividad.fecha_inicio,
          fecha_fin: actividad.fecha_fin
        });
      }catch(err){
        messages.errorMessageGraph(err);
      }
  }
  /**
   * Metodos de tabla selección y validacion  de estatus
   */
  updateStatus(item: any, campo: string, valor: any){
    item[campo] = Number(valor);

    if(campo === 'objetiveId'){
      const obj = this.objetivos.find(o => item.objetiveId === Number(o.id));
      if(!obj) item.strategiasFiltro = []
      else item.strategiasFiltro = obj.strategias;
    }

    if(((item.objetiveId !== 0) || item.tipo === 'a') && item.responsableId !== 0){
      item.status = true;
    }else{
      item.status = false;
    }
    this.canSave();
    this.countReady();

  }
  private canSave(){
    var complete = 0;
    this.registros.forEach(e =>{
      if(e.status) complete++;
    });

    if(complete === this.registros.length) this.completeAll = true;
  }
  private countReady(){
    this.error = 0;
    this.ready = 0;
    this.registros.forEach(r =>{
      r.status?this.ready++:this.error++;
    });
  }
}
